import React, { useState } from "react";
import { TodayProductivityCards } from "../common/Helper";
import { TodayProductivityModel } from "./TodayProductivityModel";
import { DescriptionIcon } from "../common/Icon";
import ProductivityDescription from "./ProductivityDescription";

import TodayWorkflow from "./TodayWorkflow";
import { useStateProvider } from "../common/StateProvider";
import { Link } from "react-router-dom";

const Productivity = () => {
  const [todayProductivityModel, setTodayProductivityModel] = useState(false);
  const { saveValueCounter, setCounterValue } = useStateProvider();
  const [indexValue, setIndexValue] = useState();
  const [cardArray, setCardArray] = useState(TodayProductivityCards);

  // Function to show the Productivity modal
  const openProductivityModal = (index) => {
    setIndexValue(index);
    setTodayProductivityModel(true);
    setCounterValue(cardArray[index].contactpercent);
  };

  return (
    <>
      <div className="pt-[9px] relative  z-10">
        <div className="bg-primary w-[318px] h-[218px] opacity-[0.67]  productivity_card_blur absolute top-[15%] md:top-0 translate-x-2/4 left-0 md:left-[20%] translate-y-1/2 -z-10"></div>
        <div className="flex items-center justify-between px-5">
          <h4 className="font-bold text-black text-sm md:text-base">
            Today's Productivity
          </h4>

          <Link to="/productivity-description">
            <DescriptionIcon />
          </Link>
        </div>
        {todayProductivityModel && (
          <TodayProductivityModel
            todayProductivityModel={todayProductivityModel}
            setTodayProductivityModel={setTodayProductivityModel}
            setIndexValue={setIndexValue}
            indexValue={indexValue}
            setCardArray={setCardArray}
          />
        )}
        <div className="pt-5 overflow-y-hidden mx-2 xs:mx-4">
          <div className="flex flex-wrap lg:flex-nowrap justify-center md:justify-between">
            {cardArray.map((obj, index) => {
              return (
                <div
                  key={index}
                  className="w-full xm:max-w-none xm:w-[46%] md:w-[49%] lg:w-[24%] py-[18px] px-[14px] rounded-lg bg-white my-2 lg:my-0  shadow-productivity_card_shadow xs:mx-2 md:mx-0 lg:mx-2">
                  <div>
                    <div className="flex items-center justify-between">
                      <img src={obj.similarIcon} alt="contact-icon" />
                      <h5 className="font-extrabold text-base md:text-xl lg:text-2xl text-black">
                        {saveValueCounter
                          ? `${cardArray[index].contactpercent}%`
                          : `${obj.contactpercent}%`}
                      </h5>
                    </div>
                    <p className="pt-1.5  font-semibold text-[14px] 3xl:text-[16px] text-black">
                      {obj.para}
                    </p>
                    <div className=" w-full h-[9px] bg-[rgba(146,_146,_146,_0.2)] rounded-[37px] mt-3.5 ">
                      <div
                        style={{
                          width: saveValueCounter
                            ? `${cardArray[index].contactpercent}%`
                            : `${obj.contactpercent}%`,
                        }}
                        className={`${obj.className} h-full rounded-[37px]`}></div>
                    </div>
                    <div className="pt-1.5 flex items-center justify-between">
                      <p className="font-medium text-[12px] 3xl:text-[14px] text-black opacity-70">
                        {obj.para2}
                      </p>
                      <span
                        onClick={() => openProductivityModal(index)}
                        className="cursor-pointer">
                        {obj.editIcon}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* TodayWorkflow DATA */}
        <TodayWorkflow />
      </div>
    </>
  );
};

export default Productivity;
